import {actions} from "./Reducer"


export const getArtisanPublicInquiryAction = (payload) => ({
    type : actions.GET_ARTISAN_PUBLIC_INQUIREY,
    payload 
})

export const getArtisanPublicInquirySuccessAction = (privateInquiry) => ({
    type : actions.GET_ARTISAN_PUBLIC_INQUIREY_SUCCESS , 
    payload : privateInquiry
})

export const getArtisnPublicInquiriesAction = (payload) => ({
    type: actions.GET_ARTISAN_PUBLIC_INQUIRIES,
    payload
})

export const getArtisanPublicInquiriesSuccessAction = (inquiries) => ({
    type: actions.GET_ARTISAN_PUBLIC_INQUIRIES_SUCCESS,
    payload: inquiries
})

export const deleteArtisanPublicInquiryAction = (id) => ({
    type: actions.DELETE_PUBLIC_ARTISAN_INQUIRY,
    payload: id
})

export const deleteArtisanPublicInquirySuccessAction = (id) => ({
    type: actions.DELETE_PUBLIC_ARTISAN_INQUIRY_SUCCESS,
    payload: id
})


export const editArtisanPublicInquiryAction = (id, body, trusted) => {
    console.log(id, body)
    return{
    type: actions.EDIT_PUBLIC_ARTISAN_INQUIRY,
    payload: {
        id,
        body
    },
    trusted
}}

export const editArtisanPublicInquirySuccessAction = (inquiry) => ({
    type: actions.EDIT_PUBLIC_ARTISAN_INQUIRY_SUCCESS,
    payload: inquiry
})


export const addArtisanPublicInquiryAction = (body, trusted) => ({
   type: actions.ADD_PUBLIC_ARTISAN_INQUIRY,
   payload: body,
   trusted
   
})

export const addArtisanPublicInquirySuccessAction = (inquiry) => ({
    type: actions.ADD_PUBLIC_ARTISAN_INQUIRY_SUCCESS,
    payload: inquiry
})

export const setArtisanPublicInquiryIsLoading = (isLoading) => ({
    type : actions.ARTISAN_PUBLIC_INQUIREY_IS_LOADING,
    payload : isLoading
})


export const setArtisanPublicInquiryCount = (isLoading) => ({
    type : actions.SET_ARTISAN_PRIVATE_INQUIRIES_COUNT,
    payload : isLoading
})


// export const getPublicArtisanProposalsAction = (p) => ({
//     type : actions.GET_ARTISAN_PUBLIC_PROPOSAL,
//     payload : isLoading
// })